import React from "react";
import styled from "styled-components";
import mondrian from "core/config/theme";
const LegendWrapper = styled.legend`
  font-family: ${mondrian.fontFamilyBase};
  font-weight: ${mondrian.fontWeightMedium};
  margin-bottom: ${mondrian.spacingStackSm};
  margin-top: ${mondrian.spacingStackSm};
  strong {
    font-weight: bold;
  }
  .mdn-Text  + .mdn-Text  {
    margin-top: ${mondrian.spacingStackXs};
  }
`;

export default function Legend(props) {
  return <LegendWrapper className="mdn-Text" {...props}>{props.children}</LegendWrapper>;
}
